import { createFileRoute } from '@tanstack/react-router'
import { LogOut } from 'lucide-react'
import { Screen } from '@/components/app/screen'
import { ScreenHeader } from '@/components/app/screen-header'
import { Skeleton } from '@/components/ui/skeleton'
import { useLogout } from '@/hooks/use-logout'
import { useMe } from '@/hooks/use-me'
import { ROLE_LABELS } from '@/lib/constants'

export const Route = createFileRoute('/_staff/profil/')({
  component: StaffProfileScreen,
})

/** Deux premières initiales du nom, à défaut de l'email. */
function initials(source: string): string {
  return source
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}

function StaffProfileScreen() {
  const logout = useLogout()
  const { data, isPending } = useMe()

  const displayName = data?.name || data?.email || ''

  return (
    <Screen withTabBar>
      <ScreenHeader title="Profil" />

      <div className="flex flex-col items-center gap-5 px-5">
        {isPending ? (
          <Skeleton className="size-20 rounded-full bg-navy-900" />
        ) : (
          <span className="flex size-20 items-center justify-center rounded-full bg-gold/15 text-[24px] font-bold text-gold">
            {initials(displayName)}
          </span>
        )}

        <div className="text-center">
          <p className="text-[20px] font-semibold text-chalk">{displayName || '—'}</p>
          {data && (
            <p className="mt-1 text-[13px] text-gold">
              {data.roles.map((role) => ROLE_LABELS[role] ?? role).join(' · ')}
            </p>
          )}
          {data?.organization && (
            <p className="mt-0.5 text-[13px] text-steel">{data.organization.name}</p>
          )}
          {data?.name && data.email && data.name !== data.email && (
            <p className="mt-2 text-[13px] text-steel">{data.email}</p>
          )}
        </div>

        <button
          type="button"
          onClick={logout}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-[14px] border border-navy-800 py-3.5 text-[15px] font-semibold text-danger"
        >
          <LogOut size={18} aria-hidden="true" />
          Se déconnecter
        </button>
      </div>
    </Screen>
  )
}
